export enum DiskWriteMode {
	ONCE = "ONCE",
	OVERWRITE = "OVERWRITE"
}

export enum FormatType {
	EXFAT = "exFAT"
}
